<template>
  <div class="section">
    <h2 class="section__title">Nearby Weather Station Readings</h2>
    <div v-if="readings.length > 0" class="station-readings">
      <div
        class="station-reading"
        v-for="reading in readings"
        :key="reading.station_id"
      >
        <h3
          class="station-reading__location"
          :title="`Station ID: ${reading.station_id}`"
        >
          {{ reading.station_name }}
        </h3>
        <div
          class="station-reading__distance"
          :title="`${reading.latitude}, ${reading.longitude}`"
        >
          {{ round(reading.distance, 0) }} miles
          {{ reading.direction }}
          <span
            class="station-reading__date"
            v-if="readingDate(reading)"
            :title="readingDate(reading).toLocaleString()"
          >
            <UseTimeAgo v-slot="{ timeAgo }" :time="readingDate(reading)">
              {{ timeAgo }}
            </UseTimeAgo>
          </span>
        </div>
        <div class="station-reading__readings">
          <div
            v-if="'snowfall_inches' in reading"
            class="reading reading--snowfall"
          >
            <div class="reading__value">
              {{ round(reading.snowfall_inches, 1) }}
              in
            </div>
            <div class="reading__type">
              snow over {{ round(reading.snowfall_duration_hours, 0) }}
              hours
            </div>
          </div>
          <div
            v-if="'snow_depth_inches' in reading"
            class="reading reading--snowdepth"
          >
            <div class="reading__value">
              {{ round(reading.snow_depth_inches, 1) }}
              in
            </div>
            <div class="reading__type">snow depth</div>
          </div>
        </div>
      </div>
    </div>
    <p v-if="readings.length > 0">
      The nearest snowfall and snow depth data from weather stations in your
      area is listed above.
    </p>
    <div v-else class="station-readings no-readings">
      <p>No station readings found nearby.</p>
    </div>
  </div>
</template>

<script>
import { round } from "@/helpers";
import { UseTimeAgo } from "@vueuse/components";
export default {
  props: ["readings"],
  components: { UseTimeAgo },
  methods: {
    round,
    readingDate(reading) {
      if (reading.snow_depth_date) {
        return new Date(reading.snow_depth_date);
      }
      if (reading.snowfall_date) {
        return new Date(reading.snowfall_date);
      }
      return null;
    }
  }
};
</script>
